import React, { useEffect, useState } from 'react';

import {
  Card,
  Input,
  Select,
  Text,
  TextArea
} from 'v3/components';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import {
  fetchCities,
  fetchDriverLicenseCategory
} from 'utils/fetches';

const CnhData = ({
  data,
  setData,
  disableFields,
  errors,
  loading
}) => {

  const [driverLicenseCategory, setDriverLicenseCategory] = useState(null);

  useEffect(() => {
    fetchDriverLicenseCategory().then(setDriverLicenseCategory);
  }, [])

  return (

    <Card
      header={
        <Text color="#464E5F" type="header">
          CNH
        </Text>
      }
    >

      <Row className="form">
        <Col xl={6} lg={6} md={12} xs={12}>
          <Input
            label="CNH *"
            value={data?.cnhNumber}
            onChange={event => setData({ ...data, cnhNumber: event.target.value })}
            disabled={disableFields || loading}
            error={errors?.['cnhData.cnhNumber']}
          />
        </Col>

        <Col xl={6} lg={6} md={12} xs={12}>
          <Select
            label="Categoria *"
            value={data?.cnhCategory}
            onChange={value => setData({ ...data, cnhCategory: value })}
            options={driverLicenseCategory}
            getOptionLabel={option => `${option.name}`}
            getOptionValue={option => option.id}
            error={errors?.['cnhData.cnhCategory']}
            isDisabled={disableFields || loading}
          />
        </Col>

        <Col xl={6} lg={6} md={12} xs={12}>
          <Input
            type="date"
            label="1º habilitação *"
            value={data?.cnhFirstCnhDate}
            onChange={event => setData({ ...data, cnhFirstCnhDate: event.target.value })}
            error={errors?.['cnhData.cnhFirstCnhDate']}
            disabled={disableFields || loading}
          />
        </Col>

        <Col xl={6} lg={6} md={12} xs={12}>
          <Input
            type="date"
            label="Data de emissão CNH *"
            value={data?.cnhDateEmission}
            onChange={event => setData({ ...data, cnhDateEmission: event.target.value })}
            error={errors?.['cnhData.cnhDateEmission']}
            disabled={disableFields || loading}
          />
        </Col>

        <Col xl={6} lg={6} md={12} xs={12}>
          <Input
            type="date"
            label="Data de validade CNH *"
            value={data?.cnhDateOfExpiration}
            onChange={event => setData({ ...data, cnhDateOfExpiration: event.target.value })}
            disabled={disableFields || loading}
            error={errors?.['cnhData.cnhDateOfExpiration']}
          />
        </Col>

        <Col xl={6} lg={6} md={12} xs={12}>
          <Select.Async
            label="Cidade emissão CNH *"
            value={data?.cnhDispatchCity}
            onChange={value => setData({ ...data, cnhDispatchCity: value })}
            getOptionLabel={option => `${option.name}`}
            getOptionValue={option => option.id}
            onSearch={search => fetchCities(search)}
            isDisabled={disableFields || loading}
            error={errors?.['cnhData.cnhDispatchCity']}
          />
        </Col>

        <Col xl={6} lg={6} md={12} xs={12}>
          <TextArea
            label="Observações CNH"
            value={data?.cnhObservations}
            onChange={e => setData({ ...data, cnhObservations: e.target.value })}
            resizable={false}
            disabled={disableFields || loading}
          />
        </Col>

        <Col xl={6} lg={6} md={12} xs={12}>
          <Input
            label="Chave da CNH"
            value={data?.cnhKey}
            onChange={event => setData({ ...data, cnhKey: event.target.value })}
            error={errors?.['cnhData.cnhKey']}
            disabled={loading}
          />
        </Col>
      </Row>
    </Card>

  )
}

export default CnhData;
